export default __webpack_public_path__ + "static/media/integrate-omny.56811db9.png";